export const STRINGS = {
  metaTitle: 'Belong Licenses',
  metaDescription:
    'Belong has real estate and insurance licenses in the following states',
  realStateLicenses: 'Real Estate Licenses',
  realStateLicensesDescription:
    'Belong, Inc. and its affiliates have real estate brokerage licenses in\u00a0the\u00a0following\u00a0states:',
  insuranceLicenses: 'Insurance Licenses',
  insuranceLicensesDescription:
    'Belong Technology Insurance Services,\u00a0Inc. has insurance licenses in\u00a0the\u00a0following\u00a0states:',
  state: 'State',
  licenseNo: 'License No.',
};
